/* ==========================================================================
   Lucent — product.js
   Media gallery, variant picker, custom bundle (quantity-tier) widget,
   sticky buy bar. Loaded only on templates that render the product section.
   ========================================================================== */
(function () {
  'use strict';

  var theme = window.theme || {};

  function $(selector, scope) {
    return (scope || document).querySelector(selector);
  }

  function $$(selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }

  function on(el, type, handler, options) {
    if (el) el.addEventListener(type, handler, options);
  }

  function money(cents) {
    return theme.formatMoney ? theme.formatMoney(cents) : (cents / 100).toFixed(2);
  }

  /* ----------------------------------------------------------- gallery -- */

  function Gallery(root) {
    var slides = $$('[data-media-slide]', root);
    if (!slides.length) return null;

    var thumbs = $$('[data-media-thumb]', root);
    var dots = $$('[data-media-dot]', root);
    var stage = $('[data-media-stage]', root);
    var index = slides.findIndex(function (slide) {
      return slide.classList.contains('is-active');
    });
    if (index < 0) index = 0;

    function pauseMedia(slide) {
      $$('video', slide).forEach(function (video) {
        if (typeof video.pause === 'function') video.pause();
      });
    }

    function go(next) {
      if (next === index || !slides[next]) return;
      pauseMedia(slides[index]);
      slides[index].classList.remove('is-active');
      slides[next].classList.add('is-active');
      if (thumbs[index]) thumbs[index].classList.remove('is-active');
      if (thumbs[next]) {
        thumbs[next].classList.add('is-active');
        thumbs[next].setAttribute('aria-current', 'true');
      }
      if (thumbs[index]) thumbs[index].removeAttribute('aria-current');
      if (dots[index]) dots[index].classList.remove('is-active');
      if (dots[next]) dots[next].classList.add('is-active');
      index = next;
    }

    function goToMediaId(id) {
      if (!id) return;
      var target = slides.findIndex(function (slide) {
        return slide.getAttribute('data-media-id') === String(id);
      });
      if (target > -1) go(target);
    }

    thumbs.forEach(function (thumb, i) {
      on(thumb, 'click', function () {
        go(i);
      });
    });

    dots.forEach(function (dot, i) {
      on(dot, 'click', function () {
        go(i);
      });
    });

    on($('[data-media-prev]', root), 'click', function () {
      go(index === 0 ? slides.length - 1 : index - 1);
    });

    on($('[data-media-next]', root), 'click', function () {
      go((index + 1) % slides.length);
    });

    /* Touch swipe on the stage. */
    if (stage) {
      var startX = 0;
      var startY = 0;
      var tracking = false;

      on(
        stage,
        'touchstart',
        function (event) {
          if (event.touches.length !== 1) {
            tracking = false;
            return;
          }
          tracking = true;
          startX = event.touches[0].clientX;
          startY = event.touches[0].clientY;
        },
        { passive: true }
      );

      on(
        stage,
        'touchend',
        function (event) {
          if (!tracking) return;
          tracking = false;
          var touch = event.changedTouches[0];
          var dx = touch.clientX - startX;
          var dy = touch.clientY - startY;
          if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
          if (dx < 0) {
            go((index + 1) % slides.length);
          } else {
            go(index === 0 ? slides.length - 1 : index - 1);
          }
        },
        { passive: true }
      );
    }

    /* Lightbox. */
    var lightbox = $('[data-lightbox]', root);
    if (lightbox) {
      var lightboxImg = $('[data-lightbox-image]', lightbox);

      on($('[data-lightbox-open]', root), 'click', function () {
        var activeImg = $('img', slides[index]);
        if (!activeImg) return;
        if (lightboxImg) {
          lightboxImg.src = activeImg.getAttribute('data-zoom-src') || activeImg.currentSrc || activeImg.src;
          lightboxImg.alt = activeImg.alt || '';
        }
        lightbox.classList.add('is-open');
        document.body.classList.add('is-locked');
      });

      on(lightbox, 'click', function (event) {
        if (event.target.closest('[data-lightbox-image]')) return;
        lightbox.classList.remove('is-open');
        document.body.classList.remove('is-locked');
      });
    }

    return { go: go, goToMediaId: goToMediaId };
  }

  /* ------------------------------------------------------------ bundle -- */

  /**
   * Quantity-tier bundle widget.
   *
   * Each tier declares a quantity, a percentage discount and (optionally) a
   * discount code. Prices shown in the widget are computed from the currently
   * selected variant, so switching colour or size re-prices every tier.
   * The discount itself is applied by the code at checkout — the tiers are
   * presentation plus the correct quantity being added to the cart.
   */
  function Bundle(root, form) {
    if (!root) return null;

    var tiers = $$('[data-tier]', root);
    if (!tiers.length) return null;

    var summary = $('[data-bundle-summary]', root);
    var summaryValue = $('[data-bundle-summary-value]', root);
    var unitPrice = 0;
    var compareAtPrice = 0;

    function selectedTier() {
      var checked = tiers.filter(function (tier) {
        return $('input', tier).checked;
      })[0];
      return checked || tiers[0];
    }

    function tierData(tier) {
      var input = $('input', tier);
      return {
        quantity: parseInt(input.getAttribute('data-quantity'), 10) || 1,
        discount: parseFloat(input.getAttribute('data-discount')) || 0,
        code: input.getAttribute('data-code') || '',
        label: input.getAttribute('data-label') || ''
      };
    }

    function render() {
      tiers.forEach(function (tier) {
        var data = tierData(tier);
        // Math.floor mirrors Liquid's integer division, so the server-rendered
        // price and the JS-updated price never differ by a cent.
        var base = (compareAtPrice > unitPrice ? compareAtPrice : unitPrice) * data.quantity;
        var total = Math.floor((unitPrice * data.quantity * (100 - data.discount)) / 100);
        var each = data.quantity ? Math.floor(total / data.quantity) : total;

        var priceEl = $('[data-tier-price]', tier);
        var compareEl = $('[data-tier-compare]', tier);
        var eachEl = $('[data-tier-each]', tier);

        if (priceEl) priceEl.textContent = money(total);
        if (compareEl) {
          if (base > total) {
            compareEl.textContent = money(base);
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }
        if (eachEl) eachEl.textContent = money(each);
      });

      var current = tierData(selectedTier());
      var currentBase = (compareAtPrice > unitPrice ? compareAtPrice : unitPrice) * current.quantity;
      var currentTotal = Math.floor((unitPrice * current.quantity * (100 - current.discount)) / 100);
      var saved = Math.max(currentBase - currentTotal, 0);

      if (summary) {
        summary.classList.toggle('is-visible', saved > 0);
        if (summaryValue) summaryValue.textContent = money(saved);
      }

      root.dispatchEvent(
        new CustomEvent('bundle:change', {
          bubbles: true,
          detail: { quantity: current.quantity, total: currentTotal, saved: saved, code: current.code }
        })
      );
    }

    tiers.forEach(function (tier) {
      on($('input', tier), 'change', render);
    });

    var controller = {
      setPrice: function (price, compareAt) {
        unitPrice = price || 0;
        compareAtPrice = compareAt || 0;
        render();
      },
      getItems: function () {
        var data = tierData(selectedTier());
        var idInput = form.querySelector('[name="id"]');
        if (!idInput || !idInput.value) return [];
        var item = {
          id: parseInt(idInput.value, 10),
          quantity: data.quantity
        };
        if (data.quantity > 1) {
          item.properties = { Bundle: data.label || data.quantity + '-pack' };
        }
        return [item];
      },
      getDiscountCode: function () {
        return tierData(selectedTier()).code;
      },
      getQuantity: function () {
        return tierData(selectedTier()).quantity;
      }
    };

    return controller;
  }


  /**
   * "Second bag" bundle widget.
   *
   * Two options: one bag, or this bag plus a second one chosen from a
   * collection, with a percentage off the second. The theme prices and labels
   * the offer; the discount itself is applied by Shopify — either an automatic
   * discount or the code on the widget.
   *
   * Prices are recomputed from the live variant and the chosen second bag, so
   * changing colour, size or second bag re-prices everything.
   */
  function BundleSecondBag(root, form) {
    if (!root) return null;

    var options = $$('[data-b2-opt]', root);
    if (!options.length) return null;

    var discount = parseInt(root.getAttribute('data-discount'), 10) || 0;
    var redirect = root.getAttribute('data-redirect') || '';
    var code = root.getAttribute('data-code') || '';
    var bundleTitle = root.getAttribute('data-bundle-title') || 'Bundle';

    var secondRow = $('[data-b2-second]', root);
    var secondIdInput = $('[data-b2-second-id]', root);
    var secondPriceInput = $('[data-b2-second-price]', root);
    var secondName = $('[data-b2-second-name]', root);
    var secondImg = $('.bundle2__second-img', root);

    var singlePriceEl = $('[data-b2-single-price]', root);
    var wasEl = $('[data-b2-was]', root);
    var nowEl = $('[data-b2-now]', root);
    var savingEl = $('[data-b2-saving]', root);
    var savingValue = $('[data-b2-saving-value]', root);

    var unitPrice = 0;

    function isBundle() {
      var checked = root.querySelector('input[type="radio"]:checked');
      return !!checked && checked.value === 'bundle';
    }

    function secondPrice() {
      return parseInt(secondPriceInput && secondPriceInput.value, 10) || 0;
    }

    /* Liquid divides integers, so mirror it here or the shown price and the
       server-side price drift by a cent. */
    function discounted(price) {
      return Math.floor((price * (100 - discount)) / 100);
    }

    function render() {
      var bundle = isBundle();
      var second = secondPrice();
      var was = unitPrice + second;
      var now = unitPrice + discounted(second);
      var saved = Math.max(was - now, 0);

      options.forEach(function (opt) {
        var input = $('input', opt);
        opt.classList.toggle('is-selected', !!input && input.checked);
      });

      if (singlePriceEl) singlePriceEl.textContent = money(unitPrice);
      if (wasEl) wasEl.textContent = money(was);
      if (nowEl) nowEl.textContent = money(now);

      if (secondRow) secondRow.hidden = !bundle;

      if (savingEl) {
        savingEl.hidden = !bundle || saved <= 0;
        if (savingValue) savingValue.textContent = money(saved);
      }

      root.dispatchEvent(
        new CustomEvent('bundle:change', {
          bubbles: true,
          detail: { quantity: bundle ? 2 : 1, total: bundle ? now : unitPrice, saved: bundle ? saved : 0, code: code }
        })
      );
    }

    options.forEach(function (opt) {
      on($('input', opt), 'change', render);
    });

    /* Choosing a bag in the picker: update the hidden inputs, the row and the
       maths, then close the drawer. Selecting a bag implies the bundle. */
    $$('[data-b2-pick]').forEach(function (button) {
      on(button, 'click', function () {
        if (secondIdInput) secondIdInput.value = button.getAttribute('data-id') || '';
        if (secondPriceInput) secondPriceInput.value = button.getAttribute('data-price') || '0';
        if (secondName) secondName.textContent = button.getAttribute('data-title') || '';

        var picked = button.querySelector('img');
        if (secondImg && picked && secondImg.tagName === 'IMG') {
          secondImg.src = picked.currentSrc || picked.src;
          if (picked.srcset) secondImg.srcset = picked.srcset;
        }

        $$('[data-b2-pick]').forEach(function (other) {
          other.removeAttribute('aria-current');
        });
        button.setAttribute('aria-current', 'true');

        var bundleRadio = root.querySelector('input[value="bundle"]');
        if (bundleRadio && !bundleRadio.checked) {
          bundleRadio.checked = true;
        }

        render();

        if (window.theme && window.theme.Drawer && typeof window.theme.Drawer.close === 'function') {
          window.theme.Drawer.close();
        }
      });
    });

    return {
      setPrice: function (price) {
        unitPrice = price || 0;
        render();
      },
      getItems: function () {
        var idInput = form.querySelector('[name="id"]');
        if (!idInput || !idInput.value) return [];

        var first = { id: parseInt(idInput.value, 10), quantity: 1 };
        if (!isBundle()) return [first];

        var secondId = parseInt(secondIdInput && secondIdInput.value, 10);
        if (!secondId) return [first];

        first.properties = { Bundle: bundleTitle };
        return [first, { id: secondId, quantity: 1, properties: { Bundle: bundleTitle } }];
      },
      getDiscountCode: function () {
        return isBundle() ? code : '';
      },
      getQuantity: function () {
        return isBundle() ? 2 : 1;
      },
      getRedirect: function () {
        return redirect || '';
      }
    };
  }

  /* ---------------------------------------------------- variant picker -- */

  function ProductForm(section) {
    var form = $('[data-product-form]', section);
    if (!form) return;

    var dataEl = $('[data-product-json]', section);
    var variants = [];
    if (dataEl) {
      try {
        variants = JSON.parse(dataEl.textContent) || [];
      } catch (error) {
        variants = [];
      }
    }

    var gallery = Gallery(section);
    var idInput = $('[name="id"]', form);
    var priceEl = $('[data-product-price]', section);
    var compareEl = $('[data-product-compare]', section);
    var priceWrap = $('[data-price-wrap]', section);
    var button = $('[data-add-button]', form);
    var buttonLabel = $('[data-add-label]', form);
    var stickyLabel = $('[data-sticky-label]', section);
    var stickyPrice = $('[data-sticky-price]', section);
    var inventoryEl = $('[data-inventory]', section);

    var bundle = Bundle($('[data-bundle]', section), form);
    if (!bundle) bundle = BundleSecondBag($('[data-bundle-second]', section), form);
    if (bundle) form.bundleController = bundle;

    function currentOptions() {
      return $$('[data-option-index]', form)
        .filter(function (input) {
          return input.checked || input.tagName === 'SELECT';
        })
        .sort(function (a, b) {
          return (
            parseInt(a.getAttribute('data-option-index'), 10) - parseInt(b.getAttribute('data-option-index'), 10)
          );
        })
        .map(function (input) {
          return input.value;
        });
    }

    function findVariant(options) {
      return (
        variants.filter(function (variant) {
          return options.every(function (value, i) {
            return variant.options[i] === value;
          });
        })[0] || null
      );
    }

    function updateAvailabilityLabels(variant) {
      $$('[data-option-value-label]', form).forEach(function (label) {
        var input = $('input', label);
        if (!input) return;
        var index = parseInt(input.getAttribute('data-option-index'), 10);
        var value = input.value;
        var candidateOptions = currentOptions().slice();
        candidateOptions[index] = value;
        var match = findVariant(candidateOptions);
        var available = !!(match && match.available);
        label.classList.toggle('swatch--soldout', !available && label.classList.contains('swatch'));
        label.classList.toggle('pill-option--soldout', !available && label.classList.contains('pill-option'));
      });

      $$('[data-option-selected]', form).forEach(function (el) {
        var index = parseInt(el.getAttribute('data-option-selected'), 10);
        if (variant && variant.options[index]) el.textContent = variant.options[index];
      });
    }

    function update() {
      var variant = findVariant(currentOptions());

      if (!variant) {
        if (idInput) idInput.value = '';
        if (button) {
          button.disabled = true;
          if (buttonLabel) buttonLabel.textContent = theme.strings ? theme.strings.unavailable : 'Unavailable';
        }
        updateAvailabilityLabels(null);
        return;
      }

      if (idInput) idInput.value = variant.id;

      if (button) {
        button.disabled = !variant.available;
        if (buttonLabel) {
          buttonLabel.textContent = variant.available
            ? (theme.strings && theme.strings.addToCart) || 'Add to cart'
            : (theme.strings && theme.strings.soldOut) || 'Sold out';
        }
      }

      if (priceEl) priceEl.textContent = money(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = money(variant.compare_at_price);
          compareEl.hidden = false;
          if (priceWrap) priceWrap.classList.add('price--on-sale');
        } else {
          compareEl.hidden = true;
          if (priceWrap) priceWrap.classList.remove('price--on-sale');
        }
      }

      if (stickyPrice) stickyPrice.textContent = money(variant.price);
      if (stickyLabel && variant.title !== 'Default Title') stickyLabel.textContent = variant.title;

      if (inventoryEl) {
        var threshold = parseInt(inventoryEl.getAttribute('data-threshold'), 10) || 0;
        var qty = variant.inventory_management ? variant.inventory_quantity : null;
        var low = threshold > 0 && typeof qty === 'number' && qty > 0 && qty <= threshold;
        inventoryEl.hidden = !variant.available;
        inventoryEl.classList.toggle('inventory--low', low);
        var text = $('[data-inventory-text]', inventoryEl);
        if (text) {
          text.textContent = low
            ? inventoryEl.getAttribute('data-text-low').replace('[count]', qty)
            : inventoryEl.getAttribute('data-text-in-stock');
        }
      }

      if (bundle) bundle.setPrice(variant.price, variant.compare_at_price);

      if (gallery && variant.featured_media && variant.featured_media.id) {
        gallery.goToMediaId(variant.featured_media.id);
      }

      updateAvailabilityLabels(variant);

      if (variant.id && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    $$('[data-option-index]', form).forEach(function (input) {
      on(input, 'change', update);
    });

    update();

    /* Sticky buy bar. */
    var stickyBar = $('[data-sticky-bar]', section);
    if (stickyBar && button) {
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              stickyBar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
            });
          },
          { rootMargin: '0px 0px -40px 0px', threshold: 0 }
        );
        observer.observe(button);
      }

      on($('[data-sticky-submit]', stickyBar), 'click', function () {
        if (window.matchMedia('(min-width: 990px)').matches) {
          form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true }));
        } else {
          button.scrollIntoView({ behavior: 'smooth', block: 'center' });
          setTimeout(function () {
            form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true }));
          }, 320);
        }
      });
    }
  }

  function initProduct(scope) {
    $$('[data-product-section]', scope || document).forEach(function (section) {
      if (section.dataset.productReady === 'true') return;
      section.dataset.productReady = 'true';
      ProductForm(section);
    });
  }

  theme.initProduct = initProduct;
  window.theme = theme;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initProduct(document);
    });
  } else {
    initProduct(document);
  }
})();
